import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { LangUpdateService } from "../_services/lang-update.service";

@Component({
  selector: "app-common-confirm-dialog",
  templateUrl: "./common-confirm-dialog.component.html",
  styleUrls: ["./common-confirm-dialog.component.scss"],
  standalone: false
})
export class CommonConfirmDialogComponent implements OnInit, OnDestroy {
  firstMessage = "";
  secondMessage = "";
  dialogType: "confirmation" | "information" = "confirmation";
  subMessages: string[] = [];

  falseBtnText = "Cancel";
  trueBtnText = "Save";
  yesBtnText = "OK";

  isWarnButton = false;
  rasedButtonColor = "primary";

  displayCancelOption = true;

  private onDestroy$ = new Subject();

  constructor(
    public dialogRef: MatDialogRef<CommonConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService,
    private langService: LangUpdateService
  ) {
    this.langService.prepare(translate, this.onDestroy$, (res) => {
      if (!data.hasOwnProperty("falseBtnText")) {
        this.falseBtnText = this.translate.instant("commonConfirmDialog.cancel");
      }
      if (!data.hasOwnProperty("trueBtnText")) {
        this.trueBtnText = this.translate.instant("commonConfirmDialog.save");
      }
      if (!data.hasOwnProperty("yesBtnText")) {
        this.yesBtnText = this.translate.instant("commonConfirmDialog.ok");
      }
    });
    if (data.hasOwnProperty("falseBtnText")) {
      this.falseBtnText = data.falseBtnText;
    }
    if (data.hasOwnProperty("trueBtnText")) {
      this.trueBtnText = data.trueBtnText;
    }
    if (data.hasOwnProperty("yesBtnText")) {
      this.yesBtnText = data.yesBtnText;
    }
    if (data.hasOwnProperty("subMessages")) {
      this.subMessages = data.subMessages;
    }

    if (data.hasOwnProperty("isWarnButton")) {
      this.rasedButtonColor = data.isWarnButton ? "warn" : "primary";
    }

    if (data.hasOwnProperty("displayCancelOption")) {
      this.displayCancelOption = data.displayCancelOption ?? true;
    }
  }

  ngOnInit() {
    this.firstMessage = this.data.firstMessage;
    this.secondMessage = this.data.secondMessage;
    this.dialogType = this.data.dialogType;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.unsubscribe();
  }
}
